@if(rawMaterialFormReady()) {
    <form autocomplete="off" [formGroup]="rawMaterialForm"
            class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
        <section class="tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
    
            <div class="tw-col-span-12 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-4 tw-pb-4">
                <div class="tw-col-span-12 md:tw-col-span-6 tw-flex tw-items-center">
                    <mat-slide-toggle formControlName="stock_type" aria-label="{{'ITEMS.RAW_MATERIALS.ENABLE_STOCK' | translate}}"
                        (change)="onToggleStockType($event)"
                        class="tw-p-3">{{'ITEMS.RAW_MATERIALS.ENABLE_STOCK' | translate}}</mat-slide-toggle>
                </div>
    
                @if(rawMaterialFormService.stock_type?.value) {
                    <div class="tw-col-span-12 md:tw-col-span-6 tw-flex tw-items-center">
                        <mat-slide-toggle formControlName="auto_unload" aria-label="{{'ITEMS.RAW_MATERIALS.AUTO_UNLOAD' | translate}}"
                            class="tw-p-3">{{'ITEMS.RAW_MATERIALS.AUTO_UNLOAD' | translate}}</mat-slide-toggle>
                    </div>
                }
            </div>
    
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                <mat-label translate>ITEMS.RAW_MATERIALS.NAME</mat-label>
                <input matInput formControlName="name" appTrimInput>
                <mat-hint [align]="'end'">{{rawMaterialFormService.name?.value?.length || '0'}}
                    / {{rawMaterialFormService.validators.nameMaxLength}}</mat-hint>
                @if(rawMaterialFormService.name?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{rawMaterialFormService.validators.nameMaxLength}})</mat-error>
                } @else if(rawMaterialFormService.name?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-3">
                <mat-label translate>ITEMS.RAW_MATERIALS.QUANTITY_ALERT</mat-label>
                <input matInput type="number" formControlName="quantity_alert"
                    [min]="rawMaterialFormService.validators.alertQuantityMinValue">
                @if(rawMaterialFormService.quantity_alert?.hasError('min')) {
                    <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-3">
                <mat-label translate>ITEMS.RAW_MATERIALS.UNIT</mat-label>
                <input matInput formControlName="unit" appTrimInput>
                <mat-hint [align]="'end'">{{rawMaterialFormService.unit?.value?.length || '0'}}
                    / {{rawMaterialFormService.validators.unitMaxLength}}</mat-hint>
                @if(rawMaterialFormService.unit?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{rawMaterialFormService.validators.unitMaxLength}})</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-9">
                <mat-label>{{'ITEMS.RAW_MATERIALS.SUPPLIER' | translate}}</mat-label>
                <input matInput formControlName="default_supplier_id" [matAutocomplete]="supplierAutocomplete" appTrimInput>
                @if(rawMaterialFormService.default_supplier_id?.hasError('matchRequired')){
                    <mat-error>{{'NG_MESSAGES.INVALID_VALUE' | translate}}</mat-error>
                }
                <mat-autocomplete #supplierAutocomplete="matAutocomplete" [displayWith]="displaySupplierName" [autoSelectActiveOption]="true">
                    @for(supplier of filteredSuppliers | async; track supplier.id) {
                        <mat-option [value]="supplier.id">{{ supplier.name }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-3">
                <mat-label translate>ITEMS.RAW_MATERIALS.COST</mat-label>
                <input matInput type="number" formControlName="cost"
                    [min]="rawMaterialFormService.validators.costMinValue">
                @if(rawMaterialFormService.cost?.hasError('min')) {
                    <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                }
            </mat-form-field>
        </section>
    </form>
}